// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Plug(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Plug" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M10 2H8V8H4V10H20V8H16V2H14V8H10V2Z", fill: "currentColor" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.5 11.5L6.5 15.5L9.5 18.5V22H14.56V18.4954L17.5 15.5L18.5 11.5H5.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Plug.js.map